import React from "react";
import HomeMain from "./HomeMain";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

import footerLogo from "../../assets/images/logos/footer-logo.png";
import PromoModal from "../../components/PromoModal/promo-modal";

const HomePage = () => {
  return (
    <>
      <Header parentMenu="home" topbarEnable="enable" />
      <PromoModal />
      <HomeMain />
      <Footer footerLogo={footerLogo} />
    </>
  );
};

export default HomePage;
